import { useMutation, useQueryClient } from "@tanstack/react-query";
import { leagueRepository } from "@/config/dataSource";
import { leaguesQueryKeys } from "@/modules/leagues/hooks/useLeagues";

export function useJoinLeague() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (inviteCode: string) => leagueRepository.joinLeagueByCode(inviteCode),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: leaguesQueryKeys.all });
    },
  });
}
